window.EVASuit = window.EVASuit || {};
window.EVASuit.Behaviors = window.EVASuit.Behaviors || {};

(function(Behaviors) {
    "use strict";

    var behavior_registry = {},
        content_ready_listeners = [];

    /**
     * Add a class to the behavior registry.
     * 
     * @param {Function} Class A behavior subclass.
     * @param {String} name The name of the class.
     * 
     * Inferred to be the class's QUERY if not provided.
     */
    function register_behavior(Class, name) {
        if (name === undefined) {
            name = Class.QUERY;
        }

        if (behavior_registry[name] === Class) {
            console.warn("Attempted to register the same behavior twice to CSS selector \"" + name + "\"");
            return;
        }

        if (behavior_registry[name] !== undefined) {
            console.error("Attempted to register a second behavior onto CSS selector \"" +
                name + "\". Only one behavior may be registered to a given CSS selector " +
                "at a given time. The offending classes are " + Class.name +
                " and " + behavior_registry[name].name + ".");
            
            return;
        }

        behavior_registry[name] = Class;
    }
    
    /**
     * Register a function that is called when content is added to the page.
     * 
     * This function should only be called for tying external code to the
     * content listener system. For example, Drupal ships its own behaviors
     * system separate from this one; you can use registered listeners to
     * trigger it when Behaviors' registry is pinged.
     * 
     * @param {Function} func The function to call when content is added.
     */
    function register_content_listener(func) {
        content_ready_listeners.push(func);
    }

    /**
     * Indicate that content has been added to the page.
     * 
     * All registered Behaviors will locate any matching elements within the
     * provided content. Each Behavior will be isolated to a separate
     * setTimeout call to prevent breaking the whole page.
     * 
     * If the page has any alternative frameworks that provide the same
     * facility of notifying JS that content has been added to the page, then
     * that facility should be altered to call this function, and this function
     * should be hotpatched to call that facility. See
     * `register_content_listener` for more information.
     * 
     * @param {jQuery|Element} context The content that was added to the page.
     */
    function content_ready(context) {
        var k, i;
        
        function do_later(obj, func) {
            window.setTimeout(func.bind(obj, context), 0);
        }
        
        for (i = 0; i < content_ready_listeners.length; i += 1) {
            do_later(undefined, content_ready_listeners[i]);
        }

        for (k in behavior_registry) {
            if (behavior_registry.hasOwnProperty(k)) {
                do_later(behavior_registry[k], behavior_registry[k].content_ready);
            }
        }
    }

    /**
     * Indicate that content is about to be removed from the page.
     * 
     * This should be called *before* removing the actual elements. Registered
     * Behaviors will stop any animations timers and remove any global
     * references to about-to-be-removed content to prevent it from consuming
     * client resources.
     * 
     * If the page has any alternative frameworks that provide the same
     * facility of notifying JS that content will be removed from the page,
     * then that facility should be altered to call this function, and this
     * function should be hotpatched to call that facility.
     * 
     * @param {jQuery|Element} context The content that was added to the page.
     */
    function content_removal(context) {
        var k, i;
        
        function do_later(obj, func) {
            window.setTimeout(func.bind(obj, context), 0);
        }
        
        for (k in behavior_registry) {
            if (behavior_registry.hasOwnProperty(k)) {
                do_later(behavior_registry[k], behavior_registry[k].content_removal);
            }
        }
    }

    window.document.addEventListener("DOMContentLoaded", function() {
        content_ready(window.document);
    });

    window.addEventListener(
        "message",
        function(event) {
            if (event.data && event.data.EVASuit &&
                event.data.EVASuit.Behaviors &&
                event.data.EVASuit.Behaviors.content_ready) {
                
                let context = document.querySelector(event.data.EVASuit.Behaviors.content_ready);
                content_ready(context);
            }
        }
    )

    Behaviors.register_behavior = register_behavior;
    Behaviors.register_content_listener = register_content_listener;
    Behaviors.content_ready = content_ready;
    Behaviors.content_removal = content_removal;
}(window.EVASuit.Behaviors));